var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "cta-wrap sm-md:flex sm-md:flex-col sm-md:w-full",
    attrs: {
      "id": "cta"
    }
  }, [_vm.styles.border === 'round' ? _c('round-button', {
    attrs: {
      "text": _vm.text,
      "url": _vm.existingParams ? `${_vm.link}?${_vm.existingParams}` : _vm.link,
      "styles": _vm.style
    }
  }) : _c('rectangle-button', {
    attrs: {
      "text": _vm.text,
      "url": _vm.existingParams ? `${_vm.link}?${_vm.existingParams}` : _vm.link,
      "styles": _vm.style
    }
  }), _vm._v(" "), _vm.ratings !== 'none' ? _c('div', {
    staticClass: "self-start"
  }, [_vm.ratings === 'appStore' ? _c('div', {
    staticClass: "cta-ratings flex items-center"
  }, [_c('div', [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "25",
      "height": "24",
      "fill": "none"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#a)"
    }
  }, [_c('path', {
    attrs: {
      "fill": "url(#b)",
      "d": "M19.262 0H4.958A4.846 4.846 0 0 0 .11 4.848v14.307A4.845 4.845 0 0 0 4.958 24h14.307a4.848 4.848 0 0 0 4.848-4.848V4.848A4.85 4.85 0 0 0 19.262 0Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#fff",
      "d": "m12.008 5.514.486-.84a1.093 1.093 0 1 1 1.896 1.092l-4.683 8.106h3.387c1.098 0 1.713 1.29 1.236 2.184H4.4a1.088 1.088 0 0 1-1.092-1.092c0-.606.486-1.092 1.092-1.092h2.784l3.564-6.177-1.113-1.932a1.095 1.095 0 0 1 1.896-1.092l.477.843ZM7.796 17.181l-1.05 1.821A1.093 1.093 0 1 1 4.85 17.91l.78-1.35c.882-.273 1.599-.063 2.166.621Zm9.042-3.303h2.841c.606 0 1.092.486 1.092 1.092 0 .606-.486 1.092-1.092 1.092h-1.578l1.065 1.848a1.095 1.095 0 0 1-1.896 1.092c-1.794-3.111-3.141-5.439-4.035-6.99-.915-1.578-.261-3.162.384-3.699.717 1.23 1.788 3.087 3.219 5.565Z"
    }
  })]), _vm._v(" "), _c('defs', [_c('linearGradient', {
    attrs: {
      "id": "b",
      "x1": "12.111",
      "x2": "12.111",
      "y1": "0",
      "y2": "24",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#18BFFB"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#2072F3"
    }
  })], 1), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "a"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#fff",
      "d": "M.11 0h24v24h-24z"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "cta-ratings-stars flex mx-4"
  }, [_c('div', {
    staticClass: "cta-ratings-star w-embed"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#CDCDCD",
      "d": "M7.74.968a.216.216 0 0 1 .412 0l1.654 5.093c.03.089.112.149.206.149h5.354c.209 0 .296.268.127.39L11.16 9.748a.216.216 0 0 0-.078.241l1.654 5.092a.216.216 0 0 1-.332.242l-4.332-3.148a.216.216 0 0 0-.254 0l-4.331 3.147a.216.216 0 0 1-.333-.24L4.81 9.988a.216.216 0 0 0-.078-.241L.4 6.6a.216.216 0 0 1 .127-.39H5.88c.094 0 .176-.06.205-.15L7.741.969Z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cta-ratings-star w-embed"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#CDCDCD",
      "d": "M7.74.968a.216.216 0 0 1 .412 0l1.654 5.093c.03.089.112.149.206.149h5.354c.209 0 .296.268.127.39L11.16 9.748a.216.216 0 0 0-.078.241l1.654 5.092a.216.216 0 0 1-.332.242l-4.332-3.148a.216.216 0 0 0-.254 0l-4.331 3.147a.216.216 0 0 1-.333-.24L4.81 9.988a.216.216 0 0 0-.078-.241L.4 6.6a.216.216 0 0 1 .127-.39H5.88c.094 0 .176-.06.205-.15L7.741.969Z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cta-ratings-star w-embed"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#CDCDCD",
      "d": "M7.74.968a.216.216 0 0 1 .412 0l1.654 5.093c.03.089.112.149.206.149h5.354c.209 0 .296.268.127.39L11.16 9.748a.216.216 0 0 0-.078.241l1.654 5.092a.216.216 0 0 1-.332.242l-4.332-3.148a.216.216 0 0 0-.254 0l-4.331 3.147a.216.216 0 0 1-.333-.24L4.81 9.988a.216.216 0 0 0-.078-.241L.4 6.6a.216.216 0 0 1 .127-.39H5.88c.094 0 .176-.06.205-.15L7.741.969Z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cta-ratings-star w-embed"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#CDCDCD",
      "d": "M7.74.968a.216.216 0 0 1 .412 0l1.654 5.093c.03.089.112.149.206.149h5.354c.209 0 .296.268.127.39L11.16 9.748a.216.216 0 0 0-.078.241l1.654 5.092a.216.216 0 0 1-.332.242l-4.332-3.148a.216.216 0 0 0-.254 0l-4.331 3.147a.216.216 0 0 1-.333-.24L4.81 9.988a.216.216 0 0 0-.078-.241L.4 6.6a.216.216 0 0 1 .127-.39H5.88c.094 0 .176-.06.205-.15L7.741.969Z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cta-ratings-star w-embed"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "9",
      "height": "16",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#CDCDCD",
      "fill-rule": "evenodd",
      "d": "M8.069.82a.212.212 0 0 0-.206.148L6.21 6.061a.216.216 0 0 1-.206.149H.65a.216.216 0 0 0-.127.39l4.332 3.148a.216.216 0 0 1 .078.241l-1.654 5.092a.216.216 0 0 0 .332.242l4.332-3.148a.216.216 0 0 1 .127-.04V.818Z",
      "clip-rule": "evenodd"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "text-block-24"
  }, [_vm._v("4.6K Ratings")])]) : _vm.ratings === 'trustPilot' ? _c('div', {
    staticClass: "cta-ratings"
  }, [_c('img', {
    attrs: {
      "src": "https://cdn.sanity.io/images/36ksfn55/sandbox/20e000a94a1b13e481d1c6850f14cdd50a0a6e57-836x88.png",
      "alt": "Extra trust pilot ratings"
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.legal && _vm.legal.length > 0 ? _c('sanity-block-content', {
    staticClass: "legal-notice sm-md:text-center",
    attrs: {
      "blocks": _vm.legal
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };